import React from 'react';
import { useClipboard } from '@/utils/clipboard';
import { useHover } from '@/utils';

type Props = {
  children: string;
  label?: string;
  mb?: number;
};

export const CopyArea = ({ label, mb, children }: Props) => {
  const clipboard = useClipboard();
  const { ref, hovered } = useHover();

  return (
    <>
      {label && <p style={{ fontSize: 12, marginBottom: 8 }}>{label}</p>}
      <div className="introduction_howto_sales_account--copy">
        <div style={{ marginBottom: mb }} {...{ ref }}>
          <textarea
            onClick={() => clipboard.copy(children)}
            readOnly
            style={{ height: `calc(1.3em + 34px)` }}
          >
            {children}
          </textarea>
        </div>
        {hovered && !clipboard.copied && (
          <p className="balloon --dark">クリックでコピー</p>
        )}
        {clipboard.copied && <p className="balloon">コピーしました</p>}
      </div>
    </>
  );
};
